<template>
  <div>
    <a-modal
      title="我要评分"
      :width="700"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel">
      <div style="height:240px;line-height:30px;">
          <a-row>
            <a-col :span="24">
                对【{{metas.name}}】进行评分
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="7">
                对流程评分
            </a-col>
            <a-col :span="17">
                <a-rate v-if="!metas.rating" v-model="star" allow-half />
                <a-rate v-else v-model="star" allow-half disabled/>
            </a-col>
          </a-row>

           <a-row>
            <a-col :span="2"></a-col>
            <a-col :span="22">
              <a-textarea 
                v-if="!metas.review"
                v-model="review"
                placeholder="您觉得流程设置合理吗？有什么需要改进的地方？" 
                :rows="4" />
                <p style="text-decoration:underline;" v-else>
                  {{metas.review}}
                </p>
            </a-col>
          </a-row>
      </div>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      confirmLoading: false,
      metas:{},
      star:4.5,
      review:'',
      visible:false
    };
  },
  inject:['reload'],
  methods: {
    showModal(e) {
        this.metas = e;
        this.visible = true;
    },
    handleOk(e) {
      if(!this.metas.review){
        let id = this.metas.id;
	      let rating = parseInt(this.star);
        let review = this.review;
        if(!rating || !review){
          this.$message.warn('请填写完整再提交');
        }else{
          this.confirmLoading = true;
          this.$store.dispatch('Rated',{id,rating,review});
          setTimeout(() => {
          this.visible = false;
          this.confirmLoading = false;
          this.reload();
        }, 500);
        }
      }else{
          this.visible = false;
      }
    },
    handleCancel(e) {
      this.visible = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/todoCenter/pjmodal.vue